const Trackman = {
  downloadJSON: () => true,
  downloadExcel: () => true,
};

export default Trackman;
